"use strict";

export class HeaderNotification {
    constructor(checkUnreadUrl) {
        this.checkUrl = checkUnreadUrl;
        this.checkUnreadMessage();
    }

    checkUnreadMessage() {
        $.ajax({
            type: "GET",
            url: this.checkUrl,
            success: (data) => {
                if (data.success && data.isUnread) {
                    // show unread notification in header mail block
                    $('#new-message-notification').css('display', 'flex');
                }
            }
        });
    }
}